// extracted by mini-css-extract-plugin
export var md = "_30-4";
export var semantic = "_30-5";
export var sm = "_30-3";
export var text = "_30-6";
export var toggleInput = "_30-0";
export var toggleSwitch = "_30-1";
export var xs = "_30-2";